import { DeviceType } from "./deviceUtil";

export type OfferLaunchMode = "redirect" | "qr";

export const isWebOfferAvailable = (operatingSystems?: string[]) =>
  operatingSystems?.includes("Windows") || operatingSystems?.includes("MacOS") || false;

export const getOfferLaunchMode = (
  deviceType: DeviceType,
  operatingSystems?: string[],
  isMobileViewport = false,
): OfferLaunchMode => {
  const shouldUseQr =
    (deviceType === "desktop" || (deviceType === "unknown" && !isMobileViewport)) &&
    !isWebOfferAvailable(operatingSystems);

  if (shouldUseQr) {
    return "qr";
  }

  return "redirect";
};
